import { useSelector, useStore } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useRef } from 'react'

import LandingZoneServicesApi from '@api/landingZones/services'

import * as landingZoneServicesMapping from '@store/landingZones/Services/action'
import * as landingZoneServicesMappingType from '@store/landingZones/Services/types'

import { useNavigate } from 'react-router-dom'
import { useAppSnackbar } from '@services/hooks/AppSnackbar'
import { useAppLoader } from '@services/hooks/AppLoader'
import { useApiError } from '@services/hooks/ApiError'

import { createId } from '@services/utils'
import { generateUrl } from '@services/routes'
import { ROUTE_LANDING_ZONES } from '@features/routes'

import { CONTEXT, useLandingZones } from '@features/hooks/LandingZones'
import { useLandingZoneMembership } from '@features/hooks/LandingZones/membership'

export const useLandingZoneServices = () => {
    const store = useStore()
    const dataStore = useSelector(state => state.landingZoneServices)
    const landingZoneServicesAction = bindActionCreators(landingZoneServicesMapping, store.dispatch)

    const { formatMembership } = useLandingZoneMembership()
    const { inLandingZones, getProvider, getRobotData } = useLandingZones()
    const { hide: hideLoader, show: showLoader } = useAppLoader()
    const { handleError: apiError } = useApiError()
    const { show: showSnack } = useAppSnackbar()
    const navigate = useNavigate()

    const loaderCallback = useRef(null)

    const getData = (index = null) => {
        if (!index) return store.getState().landingZoneServices
        return store.getState().landingZoneServices[index]
    }

    const getServices = async (id, context) => {
        try {
            const allServices = await getRobotData(id, context, {
                endpoint: '/api/applications',
                apiLoader: LandingZoneServicesApi,
                queryParams: { withOwners: 'true' }
            })

            landingZoneServicesAction.populate(allServices, () => {
                landingZoneServicesAction.setLoaded(id, format)
            })
        } catch (error) { apiError(error) }
    }

    const format = () => {
        const raw = getData()
        const grid = []

        for (let i = 0; i < raw.data.length; i++) {
            const item = raw.data[i]?.servicePrincipal
            grid.push({
                id: createId(),
                name: item.displayName ?? '-',
                objectId: item.id ?? '-',
                appId: item.appId ?? '-',
                tags: item.tags ?? [],
                data: formatMembership(item)
            })
        }

        landingZoneServicesAction.setFormat(grid, landingZoneServicesMappingType.SET_FORMAT, hideLoader)
    }

    const load = (id, callback = null) => {
        loaderCallback.current = callback

        if (dataStore.loaded === id) return

        landingZoneServicesAction.setFormat([], landingZoneServicesMappingType.SET_FORMAT, () => {
            if (!inLandingZones(id, false)) {
                hideLoader()
                showSnack(`Unknown landing zone`)
                return navigate(generateUrl(ROUTE_LANDING_ZONES))
            }

            showLoader(` `)

            const provider = getProvider(id)
            getServices(id, CONTEXT[provider])
        })
    }

    return { load }
}